import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import crypto from 'crypto-js';
import RouterUrlHelper from '../../routes/RouterUrlHelper';
// import telegramCheckingAuthorization from 'telegram-checking-authorization';
import { withAuth } from '../../features/hoc-with-auth';
const LoginPage = () => {
  const history = useHistory();
  const { isLoading } = withAuth();

  useEffect(() => {
    const $scriptCallback = document.createElement('script');
    $scriptCallback.src = '/new-script.js';

    const $scriptTelegram = document.createElement('script');
    $scriptTelegram.src = 'https://telegram.org/js/telegram-widget.js?19';
    $scriptTelegram.setAttribute('data-telegram-login', 'share_card_bot');
    $scriptTelegram.setAttribute('data-size', 'large');
    $scriptTelegram.setAttribute('data-onauth', 'onTelegramAuth(user)');
    const $exe = document.querySelector('#exe');
    if (!$exe) {
      return;
    }
    $exe.appendChild($scriptCallback);
    $exe.appendChild($scriptTelegram);
  }, []);

  useEffect(() => {
    window.addEventListener('storage', () => {
      const tgUser = window.localStorage.getItem('tgUser');

      if (tgUser) {
        history.push(RouterUrlHelper.urlMap.accounts.path);
      }
    });
  }, [history]);

  useEffect(() => {
    const tgUser = window.localStorage.getItem('tgUser');
    if (tgUser) {
      history.push(RouterUrlHelper.urlMap.accounts.path);
    }
  }, []);

  return (
    <>
      <header className={'mt-12'}>
        <div className={'flex relative justify-center items-center'}>
          <div>
            <ul className={'flex py-8'}>
              <li className={'mx-4'}>
                <a href={RouterUrlHelper.urlMap.root.path} className={'text-gray-950'}>
                  На головну
                </a>
              </li>
            </ul>
          </div>
        </div>
      </header>
      <div className={'flex justify-center items-center mt-12'}>
        <div id={'exe'}></div>
      </div>
    </>
  );
};

export default LoginPage;
